import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import ServiceItem from './ServiceItem';
import ArrowForwardSvg from '../images/arrow_forward.svg';
import ServiceOffered from './style';

function ServicesOffered({ services }) {
    const history = useHistory();
    const handleViewAllClick = (path) => {
        if (path) {
            history.push(path);
        }
    };

    const servicesConfig = [
        {
            title: 'Azure Services Offered',
            servicesList: services?.filter((service) => service.cloudProvider !== 'AWS'),
            path: '/services?services=azure',
        },
        {
            title: 'AWS Services Offered',
            servicesList: services?.filter((service) => service.cloudProvider === 'AWS'),
            path: '/services?services=aws',
        },
    ];
    const ServiceSection = ({ title, servicesList, path }) => (
        <Box sx={ServiceOffered.Offered.container}>
            <Box sx={ServiceOffered.Offered.section}>
                <Box sx={ServiceOffered.Offered.header}>
                    <Box sx={ServiceOffered.Offered.headerContent}>
                        <Typography variant="h6" sx={ServiceOffered.Offered.title}>
                            {title}
                        </Typography>
                        <Box sx={ServiceOffered.Offered.buttonContainer}>
                            <Button
                                sx={ServiceOffered.Offered.button}
                                disableRipple
                                onClick={() => handleViewAllClick(path)}
                                role="button"
                                aria-label={`View all ${title.toLowerCase()}`}
                                data-testid="view-all-services-button"
                            >
                                View All Services
                                <Box component="img" src={ArrowForwardSvg} alt="" sx={ServiceOffered.Offered.buttonIcon} />
                            </Button>
                        </Box>
                    </Box>
                </Box>
                <Box sx={ServiceOffered.Offered.servicesList}>
                    {servicesList?.slice(0, 8).map((service, index) => (
                        <ServiceItem key={index} service={service} />
                    ))}
                </Box>
            </Box>
        </Box>
    );

    ServiceSection.propTypes = {
        title: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
        servicesList: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string.isRequired,
                icon: PropTypes.string,
            })
        ).isRequired,
    };

    return (
        <Box sx={{ display: 'flex', gap: '20px', width: '100%' }}>
            {servicesConfig.map((config, index) => (
                <ServiceSection key={index} title={config.title} servicesList={config.servicesList} path={config.path} />
            ))}
        </Box>
    );
}

ServicesOffered.propTypes = {
    services: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            icon: PropTypes.string,
            cloudProvider: PropTypes.string,
        })
    ).isRequired,
};

export default ServicesOffered;
